module.exports = __webpack_public_path__ + "static/img/audioOff2.7f2e4f9c.png";